export {default, wagmiConfig} from './ExternalWalletProvider';
